import {
  INIT_GOOGLE_PHOTOS, RECEIVE_GOOGLE_PHOTOS_IMAGES,
  OPEN_LAYER_PLUGIN_MODAL, CLOSE_LAYER_PLUGIN_MODAL
} from '@/constants/ActionTypes';


export const initGooglePhotos = connectUrl => ({
  type: INIT_GOOGLE_PHOTOS,
  connectUrl,
});

export const receiveGooglePhotosImages = (images, nextPageToken) => ({
  type: RECEIVE_GOOGLE_PHOTOS_IMAGES,
  images,
  nextPageToken,
});

export const openLayerPluginModal = layerModalPluginName => ({
  type: OPEN_LAYER_PLUGIN_MODAL,
  layerModalPluginName,
});

export const closeLayerPluginModal = () => ({
  type: CLOSE_LAYER_PLUGIN_MODAL,
});
